import { useTranslation } from 'react-i18next';
import { Spinner } from '../components/ui/spinner.tsx';
import { cn } from '../lib/cn.ts';

export function PageFallback({ inline }: { inline?: boolean }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-label={t('common.loading')}
      className={cn('grid place-items-center text-ink-muted', inline ? 'min-h-64' : 'min-h-dvh bg-canvas')}
    >
      <Spinner />
    </div>
  );
}
